import { render, staticRenderFns } from "./DropdownMenu.vue?vue&type=template&id=30cfe63d&scoped=true&"
import script from "./DropdownMenu.vue?vue&type=script&lang=ts&"
export * from "./DropdownMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30cfe63d",
  null
  
)

export default component.exports